import { request, Res, requestAdmin } from './common';
import { GetAuthTokenResponse } from 'application-types';

export interface LoginReqData {
  email: string;
  email_access_code?: string;
  password: string;
}

export interface LoginResData {
  email: string;
  id: string;
  password: string;
  token: string;
}

export interface LoginResDataOk {
  isError: false;
  token: string;
  email: string;
  id: string;
}

export interface LoginResDataError {
  isError: true;
  password: string;
}

export interface GetTxTokenReq {
  channelIntegrationId: string;
  getAuthToken?: GetAuthTokenResponse;
  enableTokenManagement?: boolean;
  tenantData: GetTxTokenReqData;
}

export interface GetTxTokenReqData {
  tenant_email: string;
  tenant_account_id: string;
}

export interface GetTxTokenResData {
  token: string;
  impersonation_email: string;
  id: string;
  api_key_prefix: string;
  tenant_email?: string;
  tenant_account_id?: string;
  detail?: string;
}

export interface GetTxTokenResDataOk {
  isError: false;
  token: string;
}

export interface GetTxTokenResDataError {
  isError: true;
  error: string;
  detail?: string;
  tenantEmail?: string; 
  tenantAccountId?: string;
  errorCode?: string;
}


export async function login(data: LoginReqData): Promise<Res<LoginResData>> {
  return request(
    { token: null, method: 'post', path: '/auth/login', data },
    { raiseOnError: false }
  );
}

export async function getTxToken({
  channelIntegrationId,
  tenantData,
  getAuthToken,
  enableTokenManagement
}: GetTxTokenReq): Promise<Res<GetTxTokenResData>> {
  return requestAdmin(
    {   
      token: null, 
      channelIntegrationId, 
      method: 'post', 
      path: '/auth/txtoken', 
      data: tenantData,
      getAuthToken,
      enableTokenManagement
    },
    { raiseOnError: false }
  );
}